module.exports = __webpack_public_path__ + "media/styles/images/png/oval-teal-ab4c47aeaf76ddbc02e337f190071818.png";